import { SET_UPDATESETTING } from '../actions';

const updatesetting = (state = [], action) => {
  switch (action.type) {
	case SET_UPDATESETTING:
      return [...action.value];  
    default: return state;
  }
}

export default updatesetting;
